import { useLocation, useSearchParams } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'
import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ContactButton from 'modules/billing/components/ContactButton'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const PaymentErrorPage = () => {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()

  const emitContactCxRequest = () => {
    track(trackingEvents.onboarding.requestToContact, {
      page_path: pathname,
      page_url: window.location.href,
      request_type: 'Contact CX',
      from: 'payment_error_button',
    })
  }

  track(trackingEvents.billing.upgradePlanError, { type: searchParams.get('type') ?? 'unknown' })

  return (
    <ResponsivePage.Body variant="full">
      <Box
        flexDirection="column"
        gap="s32"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        style={{ height: '70vh' }}
      >
        <Box
          padding="s16"
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'radicalRed200',
            },
          }}
          borderRadius={{
            all: 'rel500',
          }}
        >
          <Icon.Large icon="alert" color="radicalRed1000" />
        </Box>
        <Box gap="s16" style={{ maxWidth: '540px' }}>
          <Text size="500" weight="semibold" color="grey1000">
            {i18n.t('pricing_plans.error.header.title')}
          </Text>
          <Text.Normal size="300" color="grey800">
            {i18n.t('pricing_plans.error.header.sentence')}
          </Text.Normal>
        </Box>
        <ContactButton
          type="primary"
          ctaLabel={i18n.t('pricing_plans.error.action.contact_us')}
          emitEventHandler={emitContactCxRequest}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default PaymentErrorPage
